module.exports = __webpack_public_path__ + "static/arozcaldo-b1da14b08721d2170eda29cba92ee13f.jpg";